import React, { Component } from "react";
import Button from "components/UI/Button";
import ModalOverlay from "components/UI/ModalOverlay";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { RadioGroup, RadioButton } from "react-radio-buttons";
import "./style.css";
class SearchFilter extends Component {
  state = {
    ageValue: { min: 10, max: null },
    minutesValue: { min: 0, max: null }
  };
  style = {
    headerImage: {
      height: "25px",
      width: "25px",
      backgroundColor: "fff"
    },
    modalBody: {
      width: "700px",
      padding: "3em"
    },
    button: {
      width: "230px",
      margin: "20px",
      fontSize: "20px"
    },
    iconWrapper: {
      borderRadius: "100%",
      backgroundColor: "#fff",
      margin: "0px 10px",
      height: "45px",
      width: "45px",
      padding: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    row_one: {
      display: "flex",
      justifyContent: "center"
    },
    sliders: {
      width: "100%",
      padding: "100px 20px",
      position: "relative"
      // borderRight:'1px solid #b5b5b6'
    },
    label: {
      position: "absolute",
      top: "25px",
      left: "10px",
      right: "10px",
      fontSize: "20px",
      color: "#444445",
      margin: "0px"
    },
    clear: {
      position: "absolute",
      top: "5px",
      right: "10px",
      color: "#444445",
      fontSize: "12px"
    },
    row_two: {
      padding: "10px"
    },
    headerText: {
      fontSize: "26px"
    }
  };
  header = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div style={this.style.iconWrapper}>
        <img
          style={this.style.headerImage}
          src={require("assets/images/filter-blue-nobg.png")}
          alt="Filter"
        />
      </div>
      <p style={this.style.headerText}>Search Filters</p>
    </div>
  );

  render() {
    return (
      <ModalOverlay
        close={this.props.close}
        headerStyle={{ width: "60%" }}
        header={this.header}
        bodyStyle={this.style.modalBody}
      >
        <div style={this.style.modalInner}>
          {/* <div style={{width:'80%',padding:'20px'}}><InputRange maxValue={20} minValue={0} value={this.state.value} onChange={value => this.setState({ value })}/></div> */}
          <div style={this.style.row_one}>
            <div style={this.style.sliders}>
              <p style={this.style.label}>Age</p>
              {/* <p style={this.style.clear}>CLEAR</p> */}
              <InputRange
                maxValue={120}
                minValue={10}
                value={this.state.ageValue}
                onChange={value =>
                  this.setState({ ...this.state, ageValue: value })
                }
              />
            </div>
            <div style={this.style.sliders}>
              <p style={this.style.label}>Minutes</p>
              {/* <p style={this.style.clear}>CLEAR</p> */}
              <InputRange
                maxValue={10000}
                minValue={0}
                value={this.state.minutesValue}
                onChange={value =>
                  this.setState({ ...this.state, minutesValue: value })
                }
              />
            </div>
          </div>
          <div style={this.style.row_two}>
            <RadioGroup
              onChange={value => {
                this.setState({
                  ...this.state,
                  gender: value
                });
              }}
              horizontal
            >
              <RadioButton
                value="Male"
                rootColor={"var(--secondary)"}
                pointColor={"var(--primary)"}
              >
                Male
              </RadioButton>
              <RadioButton
                value="Female"
                rootColor={"var(--secondary)"}
                pointColor={"var(--primary)"}
              >
                Female
              </RadioButton>
            </RadioGroup>
          </div>
          <Button
            onClick={() => {
              this.props.setFilter({
                age: this.state.ageValue.max ? this.state.ageValue : null,
                minutes: this.state.minutesValue.max
                  ? this.state.minutesValue
                  : null,
                gender: this.state.gender
              });
            }}
            style={this.style.button}
            type="primary"
          >
            Filter Results
          </Button>
        </div>
      </ModalOverlay>
    );
  }
}

export default SearchFilter;
